export const FEATURE_SETTING_STORE_KEY = 'FEATURE_SETTING_STORE';
